export default {
    '--full-color': '#B05FB1',
    '--light-color': '#B05FB199',
    '--main-content-grid': '#F2F2F2',
    '--title-color':'rgba(0, 0, 0, 0.87)',
    '--icon-color': '#b43eb6',
    '--grid-bg-color': '#B05EB11A',
    '--text-input-bg-color': 'rgba(217,217,217,0.53)',
    '--avatar-background': 'linear-gradient(to right, #B05FB1, #B05FB199)',
    '--reserve-background': 'linear-gradient(234deg, #803b81 20%, #ac55ad 35%)',
    '--icon-theme-filter': 'invert(15%) sepia(40%) saturate(810%) hue-rotate(180deg) brightness(94%) contrast(115%)',
    '--login-layout-background': 'linear-gradient(234deg, #6a3b81 20%, #9755ad 35%)',
    '--lbl-focused-color': '#8b0baf',
    '--focused-fieldset-color': 'rgba(134,10,175,0.5)',
    '--input-border-error-color': '#F04924',
    '--checkbox-color': '#9e4db0',
    '--color-white': '#ffffff',
    '--txt-disabled': '#ffffff',
    '--txt-success': '#b43eb6',
    '--txt-error': 'rgba(255,125,98,0.7)',
    '--disabled-bg': 'rgba(255,86,86,0.03)',
    '--txt-default': '#797979',
    '--link-color': '#7521ad',
    '--txt-gray-color': 'rgba(182, 182, 182, 1)',
    '--active-box-background': 'linear-gradient(180deg, #b63db4 0%, #ab4db2 100%)',
    '--scrollbar-bg': 'linear-gradient(200deg, #af4bb6, #9c4cb6)',
    '--active-item-background-color': 'rgba(156, 74, 175, 0.15)',
    '--input-number-border-color': 'rgba(151, 10, 173, 0.5)',
    '--input-number-focused-border-color': '#9b0aab',
    '--grid-view-background': 'linear-gradient(180deg, #ffffff 0%, #ffffff 100%)',
    '--card-view-background': 'linear-gradient(180deg, #ffffff 0%, #ffffff 100%)',
    '--btn-bg-hover': 'rgba(155,10,171,0.94)',
    '--btn-success-background': 'linear-gradient(273.72deg, #b14db4 5.88%, #aa3eb6 128.9%)',
    '--btn-success-border-color': '#a84db6',
    '--btn-gray-background-color': '#a4a4a4',
    '--btn-gray-border-color': '#aaaaaa',
    '--btn-disabled-border-color': '#e8e8e8',
    '--tab-background': 'linear-gradient(180deg, #a93fb9 0%, #9c4cb2 100%)',
    '--tab-indicator-background': 'transparent',
    '--tab-shadow': '0 4px 8px 1px rgba(161, 85, 178, 0.08)',
    '--btn-shadow': '0 4px 18px 1px rgba(161, 87, 182, 0.51)',
    '--card-shadow': '0 4px 6px 0 rgba(148, 148, 148, 0.31)',
    '--input-background-color':'#F2F2F2',
    '--select-border-color': 'rgba(89,89,89,0.8)',
    '--select-bg-color': 'rgba(236,234,234,0.9)',
    '--select-text-color': 'rgba(0,0,0,0.9)',
    '--loading-color': '#B05FB1',

}
